import { Injectable, Inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap, finalize } from 'rxjs/operators';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { NotificationService } from '../services/notification-service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
  constructor( @Inject( OKTA_CONFIG ) private oktaConfig: { oktaAuth: OktaAuth },
    private _notificationService: NotificationService ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>>
  {
    // Specify the route(s) to exclude
    const excludedRoute = '/api/SsoLogin/OktaSignIn';

    // If the request URL matches the excluded route, skip adding the token
    if (request.url.includes(excludedRoute)) {
      return next.handle(request);
    }

    return from(this.getValidAccessToken()).pipe(
      switchMap((token: string | undefined) => {
        const authReq = token
          ? request.clone({ setHeaders: { 'Authorization': `Bearer ${token}` } })
          : request;
        return next.handle(authReq);
      }),
      catchError( ( error: HttpErrorResponse ) =>
      {
        if ( error.status === 200 )
        {
          console.info( error );
        }          
        if (error.status === 401) {
          // Optionally, sign out or redirect to login
          //this.oktaConfig.oktaAuth.signOut();
          this._notificationService.showErrorMessage( 'Unauthorized request. Please log in again.' );          
        }        
        return throwError(() => error );
      }),
      finalize(() => {
        // Optional: cleanup logic
      })
    );
  }

  private async getValidAccessToken(): Promise<string | undefined> {
    const oktaAuth = this.oktaConfig.oktaAuth;
    let accessToken = await oktaAuth.getAccessToken();    
    return accessToken;
  }   
  
}
